// extracted by mini-css-extract-plugin
module.exports = {"scrollableArea":"tabsList_scrollableArea__VMwCh","scrollableWrapper":"tabsList_scrollableWrapper__VC7MT","isVisibleOverflow":"tabsList_isVisibleOverflow__poIQw"};